import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import textTypes from '../textLabel/textTypes';
import Toggle from '../toggle/toggle';
import _Symbol from './switchIcon.js';
import InfoIcon from '../infoIcon/infoIcon';
import classNames from 'classnames';
var SIZES = {
  MEDIUM: 'switch-size-medium'
};
var toggleSwitch = /*#__PURE__*/function (_React$Component) {
  function toggleSwitch(props) {
    var _this;
    _classCallCheck(this, toggleSwitch);
    _this = _callSuper(this, toggleSwitch, [props]);
    _defineProperty(_this, "_renderSymbol", function () {
      var symbol = _this.props.symbol;
      return /*#__PURE__*/React.createElement("span", {
        key: "symbol-image",
        className: "symbol-image",
        tabIndex: "0"
      }, symbol);
    });
    _defineProperty(_this, "_renderLabel", function () {
      var _this$props = _this.props,
        value = _this$props.value,
        translateIfNeeded = _this$props.translateIfNeeded,
        label = _this$props.label,
        labelAfterSymbol = _this$props.labelAfterSymbol,
        symbol = _this$props.symbol;
      return /*#__PURE__*/React.createElement("span", {
        className: classNames('label label-switch', _this.getLabelType(), {
          'label-after-symbol': labelAfterSymbol,
          'symbol-after-label': symbol && label && !labelAfterSymbol
        }),
        key: "label",
        onClick: _this.onLabelClick,
        tabIndex: "0",
        "aria-checked": value
      }, translateIfNeeded(label));
    });
    _defineProperty(_this, "_renderToggle", function () {
      var value = _this.props.value;
      return /*#__PURE__*/React.createElement("span", {
        role: "switch",
        "aria-checked": value,
        className: "symbol symbol-switch",
        onKeyPress: _this.pressKeyButton,
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement(_Symbol, {
        filterId: _this.randomFilterId
      }));
    });
    _defineProperty(_this, "_renderInfoIcon", function () {
      var _this$props2 = _this.props,
        infoIconProps = _this$props2.infoIconProps,
        labelAfterSymbol = _this$props2.labelAfterSymbol;
      return /*#__PURE__*/React.createElement("span", {
        className: classNames('info-icon', {
          'before-toggle': !labelAfterSymbol
        })
      }, /*#__PURE__*/React.createElement(InfoIcon, infoIconProps));
    });
    var className = _this.props.getClassName('control-switch') + (_this.props.animated ? ' control-switch-animated' : '') + (_this.props.size ? " ".concat(SIZES[_this.props.size]) : '') + (_this.props.widthByTextLength ? ' width-by-text-length' : '') + (_this.props.onCheck ? ' has-on-check' : '');
    _this.getToggleProps = function () {
      return _.assign({}, _this.props, {
        className: className,
        name: 'switch'
      });
    };
    _this.getLabelType = function () {
      return props.labelType.toLowerCase();
    };
    _this.pressKeyButton = function (e) {
      if (e.which === 32 || e.which === 13) {
        e.preventDefault();
        if (_this.props.onChange) {
          _this.props.onChange(!_this.props.value);
        }
      }
    };
    _this.onLabelClick = function (e) {
      if (_this.props.onCheck) {
        e.preventDefault();
        _this.props.onCheck();
      }
    };
    _this.randomFilterId = Math.random().toString(36).substring(7);
    return _this;
  }
  _inherits(toggleSwitch, _React$Component);
  return _createClass(toggleSwitch, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        dataHook = _this$props3.dataHook,
        automationId = _this$props3.automationId,
        symbol = _this$props3.symbol,
        label = _this$props3.label,
        labelAfterSymbol = _this$props3.labelAfterSymbol,
        infoIconProps = _this$props3.infoIconProps,
        children = _this$props3.children;
      return /*#__PURE__*/React.createElement(Toggle, _.assign({}, {
        'data-hook': dataHook,
        'data-aid': automationId
      }, this.getToggleProps()), symbol && this._renderSymbol(), !labelAfterSymbol && /*#__PURE__*/React.createElement(React.Fragment, null, label && this._renderLabel(), infoIconProps && this._renderInfoIcon()), this._renderToggle(), labelAfterSymbol && /*#__PURE__*/React.createElement(React.Fragment, null, label && this._renderLabel(), infoIconProps && this._renderInfoIcon()), children);
    }
  }]);
}(React.Component);
toggleSwitch.displayName = 'ToggleSwitch';
toggleSwitch.propTypes = {
  /** lable text to display */
  label: PropTypes.string,
  /** whether the lable should be shown before or after the toggle switch */
  labelAfterSymbol: PropTypes.bool,
  /** the lable type */
  labelType: PropTypes.oneOf(textTypes.TYPES),
  /** should animated the toggle between true or false */
  animated: PropTypes.bool,
  /** disables the toggle switch */
  disabled: PropTypes.bool,
  /** toggle value */
  value: PropTypes.bool.isRequired,
  /** a callback called with the new value when clicking on the toggle switch */
  onChange: PropTypes.func,
  /** a callback called on toggle switch to 'true' */
  onCheck: PropTypes.func,
  /** toggle size: can be default or 'MEDIUM' */
  size: PropTypes.oneOf(_.keys(SIZES)),
  /** set toggle switch width by lable text length */
  widthByTextLength: PropTypes.bool,
  /** render symbol element before toggle switch*/
  symbol: PropTypes.element,
  /** A callback function to be called on mouseEnter event */
  onMouseEnter: PropTypes.func,
  /** A callback function to be called on mouseLeave event */
  onMouseLeave: PropTypes.func,
  /** Renders an <InfoIcon/> on hover with relevant props when defined */
  infoIconProps: PropTypes.object
};
toggleSwitch.defaultProps = {
  labelAfterSymbol: false,
  animated: true,
  labelType: textTypes.DEFAULT_TYPE,
  widthByTextLength: false
};
export default compose(toggleSwitch);
export { SIZES };